import jwtDecode from 'jwt-decode'
import {AUTH_URL} from '../../utils/endpoints'
import {clientIdFromAccessToken, resolveMapZoneMode} from '../../utils/clientId'
import axios from 'axios'

const SET_PROFILE = 'SET_PROFILE'
const CLEAR_PROFILE = 'CLEAR_PROFILE'
const SET_ROLE = 'SET_ROLE'
const SET_ADMINROLE = 'SET_ADMINROLE'
const SET_OPERA = 'SET_OPERA'
const SET_ID_TOKEN = 'SET_ID_TOKEN'
const SET_CLIENT_ID = 'SET_CLIENT_ID'
const SET_MAP_ZONE_MODE = 'SET_MAP_ZONE_MODE'
const SET_MOBILEROLE = 'SET_MOBILEROLE'
const SET_HAS_ONLY_MOBILEROLE = 'SET_HAS_ONLY_MOBILEROLE'
const SET_SHOW_LOGOUT_MODAL = 'SET_SHOW_LOGOUT_MODAL'

const authModule = {
  namespaced: true,
  state: {
    idToken: null,
    opera: 1,
    adminRole: null,
    roleLoaded: false,
    role: [],
    profile: {},
    authenticated: () => {
      if (localStorage.getItem('idToken') && localStorage.getItem('accessToken')) {
        const info = jwtDecode(localStorage.getItem('idToken'))
        const accInfo = jwtDecode(localStorage.getItem('accessToken'))
        // console.log('INFO EXP: ', info.exp)
        const expired = hasExpired(info.exp)
        const expiredAcc = hasExpired(accInfo.exp)
        // console.log(expired)
        const result = expired && expiredAcc
        return !result
      } else {
        return false
      }
    },
    mobileRole: null,
    hasOnlyMobileRole: false,
    showLogoutModal: false,
    clientId: 1,
    mapZoneMode: 'medellin'
  },
  getters: {
    idToken: state => state.idToken,
    clientId: state => state.clientId,
    mapZoneMode: state => state.mapZoneMode,
    opera: state => state.opera,
    adminRole: state => state.adminRole,
    roleLoaded: state => state.roleLoaded,
    role: state => state.role,
    getProfile: state => {
      return state.profile
    },
    authenticated: state => state.authenticated,
    mobileRole: state => state.mobileRole,
    hasOnlyMobileRole: state => state.hasOnlyMobileRole,
    showLogoutModal: state => state.showLogoutModal
  },
  mutations: {
    [SET_ID_TOKEN](state) {
      state.idToken = localStorage.getItem('idToken')
    },
    [SET_CLIENT_ID](state, value) {
      state.clientId = value
    },
    [SET_MAP_ZONE_MODE](state, value) {
      state.mapZoneMode = value
    },
    [SET_OPERA](state, value) {
      state.opera = Number(value)
    },
    [SET_ADMINROLE](state, value) {
      state.adminRole = value
    },
    [SET_ROLE](state, value) {
      state.roleLoaded = true
      state.role = value
    },
    [SET_PROFILE](state, profile) {
      state.profile = profile
    },
    [CLEAR_PROFILE](state) {
      state.profile = {}
    },
    [SET_MOBILEROLE](state, value) {
      state.mobileRole = value
    },
    [SET_HAS_ONLY_MOBILEROLE](state, value) {
      state.hasOnlyMobileRole = value
    },
    [SET_SHOW_LOGOUT_MODAL](state, value) {
      state.showLogoutModal = value
    }
  },
  actions: {
    setRole({commit}) {
      const AT = jwtDecode(localStorage.getItem('accessToken'))
      const scope = AT.scope
      const scopeArray = scope.split(' ')
      const role = scopeArray.filter(item => item.includes('avl:ROLE'))
      // console.log('ROLE', role)
      const opera = scopeArray.filter(item => item.includes('avl:OPERA'))

      let operaID = null
      if (opera.length > 0) {
        // console.log('OPERA: ', opera)
        operaID = opera[0].split(':')
        commit(SET_OPERA, operaID[2])
        // console.log('OPERA ID: ', operaID[2])
      }

      let adminRole = scopeArray.filter(item => item.includes('avl:ADMINROLE'))
      // console.log('ADMINROLE SCOPE: ', adminRole)
      if (adminRole.length > 0) {
        const adminRoleIn = adminRole[0].split(':')
        adminRole = Number(adminRoleIn[2])
      } else adminRole = null
      // console.log('ADMINROLE: ', adminRole)

      const realRole = []
      if (role.length > 0) {
        role.forEach(element => {
          const roleArray = element.split(':')
          realRole.push(Number(roleArray[2]))
        })
      }

      // if (realRole.length === 1 && realRole[0] === 23) {
      //   commit(SET_OPERA, operaID[2])
      // }
      // console.log('REAL ROLE: ', realRole)

      let mobileRole = scopeArray.filter(item => item.includes('avl:MROLE'))
      if (mobileRole.length > 0) {
        // console.log('mobileRole:', mobileRole)
        const mobileRoleIn = mobileRole[0].split(':')
        mobileRole = Number(mobileRoleIn[2])
      } else mobileRole = null

      const hasOnlyMobileRole = mobileRole !== null && (adminRole === null && realRole.length === 0)

      commit(SET_ADMINROLE, adminRole)
      commit(SET_ROLE, realRole)
      commit(SET_MOBILEROLE, mobileRole)
      commit(SET_HAS_ONLY_MOBILEROLE, hasOnlyMobileRole)
      const clientId = clientIdFromAccessToken()
      commit(SET_CLIENT_ID, clientId)
      commit(SET_MAP_ZONE_MODE, resolveMapZoneMode({
        tokenClientId: clientId,
        isAdmin: adminRole !== null,
        roleAgencyIds: realRole,
        agenciesTree: []
      }))
    },
    setMapZoneMode({commit}, mode) {
      commit(SET_MAP_ZONE_MODE, mode)
    },
    setProfile({commit}) {
      const profile = jwtDecode(localStorage.getItem('idToken'))
      const email = profile['https://omnitrack.com.co/email']
      profile.email = email
      commit(SET_PROFILE, profile)
    },
    clearProfile({commit}) {
      commit(CLEAR_PROFILE)
    },
    login({dispatch, commit}, authResult) {
      // console.log('Login')
      return new Promise((resolve, reject) => {
        const {accessToken, idToken} = authResult
        try {
          const info = jwtDecode(idToken)
          const accInfo = jwtDecode(accessToken)
          const exp = info.exp
          const expAcc = accInfo.exp
          if (hasExpired(exp) || hasExpired(expAcc)) {
            dispatch('logout')
            resolve(false)
          } else {
            setSession(authResult)
            commit(SET_ID_TOKEN)
            // dispatch('setProfile', info)
            // dispatch('setRol', accInfo)
            resolve(true)
          }
        } catch (e) {
          console.error(e)
        }
      })
    },

    checkSession({dispatch}) {
      // console.log('checkSession')
      if (localStorage.getItem('accessToken') !== null && localStorage.getItem('idToken') !== null) {
        let authResult = {
          accessToken: localStorage.getItem('accessToken'),
          idToken: localStorage.getItem('idToken')
        }
        dispatch('login', authResult)
      }
    },

    async logout({commit, dispatch}) {
      if (localStorage.getItem('accessToken') && localStorage.getItem('idToken')) {
        commit(SET_SHOW_LOGOUT_MODAL, true)
        await dispatch('setLogHistoryAuth', 'logout', {root: true})
        localStorage.removeItem('accessToken')
        localStorage.removeItem('idToken')
      }
      localStorage.clear()
      dispatch('clearProfile')
      window.location.replace(`${AUTH_URL}?redirectUri=${window.location.origin}`)
    },
    getUserInfo(idToken) {
      return jwtDecode(idToken)
    },
    isAuthenticated({dispatch, commit}) {
      // console.log('isAuthenticated')
      if (localStorage.getItem('idToken') && localStorage.getItem('accessToken')) {
        const info = jwtDecode(localStorage.getItem('idToken'))
        const accInfo = jwtDecode(localStorage.getItem('accessToken'))
        const expired = hasExpired(info.exp)
        const expiredAcc = hasExpired(accInfo.exp)
        const result = expired && expiredAcc
        // console.log('isAuthenticated Result: ', !result)
        if (!result) {
          dispatch('setProfile', info)
          dispatch('setRole', accInfo)
          commit(SET_ID_TOKEN)
        }
        return !result
      // }
      // if (localStorage.getItem('idToken')) {
      //   let info = jwtDecode(localStorage.getItem('idToken'))
      //   return !hasExpired(info.exp)
      } else {
        return false
      }
    }
  }
}

// function getTokenExpirationDate(encodedToken) {
//   const token = jwtDecode(encodedToken)
//   if (!token.exp) { return null }

//   const date = new Date(0)
//   date.setUTCSeconds(token.exp)

//   return date
// }

function setSession(authResult) {
  localStorage.setItem('accessToken', authResult.accessToken)
  localStorage.setItem('idToken', authResult.idToken)

  axios.defaults.headers.common['Content-type'] = 'application/json'
  axios.defaults.headers.common['Accept'] = 'application/json'
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
  axios.defaults.params = {}
  axios.defaults.params['idToken'] = localStorage.getItem('idToken')
}

function hasExpired(expiration) {
  // const expirationDate = getTokenExpirationDate(token)
  // return expirationDate < new Date()
  const date = new Date(0)
  const expTime = date.setUTCSeconds(expiration)
  // console.log(`${expTime} --- ${date.getTime()}`)
  // console.log(`${expTime} --- ${new Date().getTime()}`)
  return expTime < new Date().getTime()
}

export default authModule



// WEBPACK FOOTER //
// ./src/store/modules/auth.js